const PdfFileIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 36 16" aria-hidden="true" className={className}>
    <text
      x="18"
      y="8"
      fill="currentColor"
      fontSize="10"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      PDF
    </text>
  </svg>
)

export default PdfFileIcon
